module.exports = __webpack_public_path__ + "static/img/tcqn1.021a03e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/tcqn1.png
// module id = 380
// module chunks = 0